import { isIdSegment } from "@/shared/lib/id-segment";

/**
 * Route of the user detail page. An id that is not a plain id segment (it came
 * from the API, but `.` / `..` would resolve to another route) falls back to
 * the users list.
 */
export function userPath(userId: string): string {
  return isIdSegment(userId) ? `/users/${userId}` : "/users";
}
